var _path, _path2, _path3, _path4, _path5, _path6, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcept(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warn",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16322",
    "data-name": "\\uD328\\uC2A4 16322",
    d: "M512,256A255.966,255.966,0,0,1,257.68,511.988c-.168,0-.352.012-.52,0-.379.012-.77.012-1.16.012A255.995,255.995,0,0,1,74.988,74.98,254.323,254.323,0,0,1,256,0c.391,0,.77,0,1.16.012.18,0,.359,0,.539.008A255.973,255.973,0,0,1,512,256Zm0,0",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16323",
    "data-name": "\\uD328\\uC2A4 16323",
    d: "M512,256A255.966,255.966,0,0,1,257.68,511.988c-.168,0-.352.012-.52,0V.012c.18,0,.359,0,.539.008A255.973,255.973,0,0,1,512,256Zm0,0",
    fill: "#676767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16324",
    "data-name": "\\uD328\\uC2A4 16324",
    d: "M257.266,107.8C257.684,107.8,256.9,107.8,257.266,107.8Zm0,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16325",
    "data-name": "\\uD328\\uC2A4 16325",
    d: "M299.922,150.461V264.9a42.7,42.7,0,0,1-42.652,42.66h-.109c-10.988-.32-22.332-4.758-30.059-12.488A42.41,42.41,0,0,1,214.609,264.9V150.461c0-23.262,19.313-41.992,42.551-42.66h.109A42.706,42.706,0,0,1,299.922,150.461Zm0,0",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16326",
    "data-name": "\\uD328\\uC2A4 16326",
    d: "M257.266,307.563C256.9,307.563,257.629,307.57,257.266,307.563Zm0,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16327",
    "data-name": "\\uD328\\uC2A4 16327",
    d: "M297.641,361.641a40.419,40.419,0,0,1-40.379,40.379h-.1a40.375,40.375,0,0,1,0-80.75h.1A40.417,40.417,0,0,1,297.641,361.641Zm0,0",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1852",
    "data-name": "\\uADF8\\uB8F9 1852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16328",
    "data-name": "\\uD328\\uC2A4 16328",
    d: "M297.641,361.641a40.419,40.419,0,0,1-40.379,40.379h-.1V321.27h.1A40.417,40.417,0,0,1,297.641,361.641Zm0,0",
    fill: "#ddebf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16329",
    "data-name": "\\uD328\\uC2A4 16329",
    d: "M299.922,150.461V264.9a42.7,42.7,0,0,1-42.652,42.66h-.109V107.8h.109A42.706,42.706,0,0,1,299.922,150.461Zm0,0",
    fill: "#ddebf0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcept);
export default __webpack_public_path__ + "static/media/except.e55ed7c4b73f85cc5a8ecd2242816db3.svg";
export { ForwardRef as ReactComponent };